import React from 'react';
import { homepagePrimaryButtonClassName, homepageSectionContainerClassName } from '../constants/homepageUi';
import { HomepageImageGlowWrap } from './HomepageImageGlow';

/** Full image visible: width = column, height follows file aspect ratio (no object-cover crop). */
const heroImageClassName =
  'w-full h-auto max-w-full rounded-2xl shadow-[0_8px_48px_rgba(0,0,0,0.35)]';

const HeroSection: React.FC = () => {
  return (
    <section className="bg-[#0B0F14] pt-16 pb-20 lg:pt-24 lg:pb-28">
      <div className={homepageSectionContainerClassName}>
        <div className="flex flex-col lg:flex-row lg:items-stretch gap-12 lg:gap-14 xl:gap-16">
          <div className="w-full lg:w-[40%] lg:max-w-[40%] flex flex-col justify-center lg:pr-4">
            <h1 className="text-4xl sm:text-5xl lg:text-[2.75rem] xl:text-6xl font-bold text-white tracking-tight leading-[1.1] mb-8">
              Custom AI Training Data—Captured in the Real World
            </h1>
            <p className="text-base sm:text-lg text-white/90 leading-relaxed mb-6">
              Generate production-grade image and video datasets on demand. Real-world collection, human validation, and AI-assisted labeling—delivered in COCO, YOLO, and the formats your training stack expects.
            </p>
            <p className="text-sm sm:text-base text-white/80 leading-relaxed mb-10">
              Built for AI teams, robotics companies, and computer vision engineers shipping models outside the lab.
            </p>
            <a href="/request-dataset" className={homepagePrimaryButtonClassName}>
              Request a Dataset
            </a>
          </div>

          <div className="w-full lg:w-[60%] lg:max-w-[60%] flex justify-center lg:justify-end">
            <HomepageImageGlowWrap className="w-full max-w-full">
              <img
                src="/assets/home-hero.png"
                alt="Real-world environments for AI training data"
                className={heroImageClassName}
                decoding="async"
              />
            </HomepageImageGlowWrap>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
